import type { DefinitionList } from "../definition-list";

export const definiciones: DefinitionList = {
  title: "Definiciones",
  terms: {
    "Investigación política": {
      definitions: [
        {
          paragraphs: [
            "investigación experimental, colectiva y operativa. Fundada en los flujos de información disponible y no en la realidad de nuestro metro cuadrado, ni en principios abstractos. Construida en función de criterios de verosimilitud política y rigurosidad, bajo la apuesta por reinventar los modos en que producimos verdad. Va más allá de la lógica académica, judicial y periodística: aprender de los modos académicos pero sin distanciarse de la conflictividad política del presente; superar la lógica judicial, que delega tanto el esclarecimiento de los hechos como la posibilidad de resolución en dependencias estatales y; desafiar el lenguaje periodístico, que muchas veces corre el riesgo de moverse al frenético compás de la coyuntura y nos convierte en consumidores de sucesos sobre los que parecemos no tener posibilidad de incidir.",
          ],
        },
      ],
      members: [],
    },
    "Violencia política": {
      definitions: [
        {
          paragraphs: [
            "entendemos por este tipo de violencia aquellos ataques con un mensaje político que apuntan a silenciar activismos, hostigar y amedrentar activistas, destruir espacios y símbolos vinculados a militancias y reivindicaciones progresistas. Adquieren una modalidad particular cuando se trata de ataques específicamente dirigidos a activistas mujeres / feministas; activistas o personas de la comunidad LGTBIQ+ y activistas y miembros de comunidades de pueblos originarios, en donde la carga de violencia de ultraderecha muestra además su faz misógina, homo-lesbo-transodiante y racista. Esta violencia puede darse en espacios físicos y en espacios digitales. Entre estas últimas contamos al doxeo.",
          ],
        },
      ],
      members: [],
    },
    Ultraderecha: {
      definitions: [
        {
          paragraphs: [
            "Empleamos este término  para referirnos a un amplio ecosistema que contiene grupos, movimientos y partidos políticos (de derecha), que expresan su identidad política mediante estrategias como la negación y el odio hacia identidades y colectivos que ubican bajo la figura de “enemigo” -lo que propicia su eliminación-, antes que un antagonista o simple opositor.",
          ],
        },
      ],
      members: [],
    },
    "Derechas radicalizadas": {
      definitions: [
        {
          paragraphs: [
            "llamamos derechas radicalizadas a aquellos sectores de la ultraderecha que apelan directa o indirectamente a la violencia como método de intervención política. No se trata de un calificativo orientado al contenido de sus ideas, sino a las agresiones y ataques desplegados con intención de silenciar, amedrentar, disciplinar o eliminar a todo aquel que percibe como un otro como forma de influir en la discusión pública e inhibir su participación.",
          ],
        },
      ],
      members: [],
    },
    "Ataques de derechas radicalizadas": {
      definitions: [
        {
          paragraphs: [
            "Entendemos por ataques de derecha radicalizada aquellas acciones que expresan un deseo de aniquilación del otro con el objeto de silenciar, amedrentar, disciplinar o eliminar identidades políticas como forma de influir en la discusión pública e inhibir su participación.",
          ],
        },
      ],
      members: [],
    },
    "Discursos de odio": {
      definitions: [
        {
          paragraphs: [
            "siguiendo la definición del Laboratorio de Estudios sobre Democracia y Autoritarismos (LEDA - Universidad de San Martín - Argentina) entendemos por discursos de odio a cualquier tipo de discurso pronunciado en la esfera pública que procure promover, incitar o legitimar la discriminación, la deshumanización y/o la violencia hacia una persona o un grupo de personas en función de la pertenencia de las mismas a un grupo religioso, étnico, nacional, político, racial, de género o cualquier otra identidad social.",
          ],
        },
      ],
      members: [],
    },
    "Ataques geolocalizables": {
      definitions: [
        {
          paragraphs: [
            "se vincula con la materialidad del ataque, en tanto ocurren en un espacio físico, sea contra personas o contra objetos/lugares, y por eso la acción puede ser mapeada dentro de coordenadas geográficas. Dentro de esta clase de ataque ubicamos a los que ocurren sobre símbolos y lugares; el hostigamiento e intimidación; y los atentados contra la integridad física y la vida.",
          ],
        },
      ],
      members: [],
    },
    Doxeos: {
      definitions: [
        {
          paragraphs: [
            "consiste en la obtención y publicación de información personal de alguien o de un grupo sin su consentimiento en redes sociales, con el objetivo de generar acciones o agresiones en su contra. Su intensidad puede escalar desde mensajes amenazantes en el ámbito digital a partir de dichos datos, hasta su continuación en el ámbito material a través de acciones de amenaza, hostigación o agresión física hacia esa persona o su entorno.",
          ],
        },
      ],
      members: [],
    },
    Autocuidado: {
      definitions: [
        {
          paragraphs: [
            "apuntamos a desarrollar desde la inteligencia colectiva dispositivos de respuesta a la violencia proveniente de las derechas radicalizadas, que no dependan en primera instancia de los mecanismos institucionales. La información, su sistematización y compresión en sentido estratégico, resultan claves para construir nuevas formas de cuidado.",
          ],
        },
      ],
      members: [],
    },
  },
};
